import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { getNavn } from './utils/utils.js'
import { getOptionTask } from './api/home.js'
import axios from 'axios'
axios.defaults.baseURL = ''
import ElementUI from 'element-ui'
//引入阿里巴巴矢量图
import '@/assets/iconfont/iconfont.css'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'

Vue.use(Avue)
Vue.use(ElementUI)
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.prototype.$axios = axios
Vue.prototype.$getNavn = getNavn
Vue.prototype.$getOptionTask = getOptionTask
Vue.config.productionTip = false
import 'default-passive-events'
import animate from 'animate.css'
Vue.use(animate)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
